
import type { RouteRecordRaw } from 'vue-router'
export default <RouteRecordRaw[]>[
    {
        path: '/chinadaily-union-SAASPCCodeEntry',
        name: 'chinadaily-union-SAASPCCodeEntry',
        component: () => import('../views/customEnterprise/chinadaily-union/index.vue')
    },
    {
        path: '/chinadaily-development-SAASPCCodeEntry',
        name: 'chinadaily-development-SAASPCCodeEntry',
        component: () => import('../views/customEnterprise/chinadaily-development/index.vue')
    },
    {
        path: '/chinadaily-SAASPCCodeEntry',
        name: 'chinadaily-SAASPCCodeEntry',
        component: () => import('../views/customEnterprise/chinadaily/index.vue')
    },
    {
        path: '/canon',
        name: 'canon',
        component: () => import('../views/customEnterprise/canon/index.vue')
    },
    {
        path: '/cdf-movie-SAASPCPassEntry',
        name: 'cdf-movie-SAASPCPassEntry',
        component: () => import('../views/customEnterprise/cdf-movie/index.vue')
    },
    {
        path: '/cdf-condolences-SAASPCPassEntry',
        name: 'cdf-condolences-SAASPCPassEntry',
        component: () => import('../views/customEnterprise/cdf-condolences/index.vue')
    },
    {
        path: '/volvocars-SAASPCCodeEntry',
        name: 'volvocars-SAASPCCodeEntry',
        meta: {title: '沃尔沃蓝色血液积分平台'},
        component: () => import('../views/customEnterprise/volvocars/index.vue')
    },
    {
        path: '/cestc-SAASPCCodeEntry',
        name: 'cestc-SAASPCCodeEntry',
        meta: {title: '中国系统'},
        component: () => import('../views/customEnterprise/cestc/index.vue')
    },
    {
        path: '/hyundai-SAASPCCodeEntry',
        name: 'hyundai-SAASPCCodeEntry',
        meta: {title: '北京现代年货大集'},
        component: () => import('../views/customEnterprise/hyundai/index.vue')
    },
    {
        path: '/microsoft-SAASPCPassEntry',
        name: 'microsoft-SAASPCPassEntry',
        meta: {title: '微软'},
        component: () => import('../views/customEnterprise/microsoft/index.vue')
    },
    {
        path: '/volvocars-total-SAASPCCodeEntry',
        name: 'olvocars-total-SAASPCCodeEntry',
        meta: { title: '沃尔沃北京联合工会福利平台' },
        component: () => import('../views/customEnterprise/volvocars-total/index.vue')
    },
    {
        path: '/chinadaily-local-SAASPCCodeEntry',
        name: 'chinadaily-local-SAASPCCodeEntry',
        component: () => import('../views/customEnterprise/chinadaily-local/index.vue')
    }
]